import axios from 'axios'

const useAxios = async (payload) => {
  const { baseURL, endpoint, data, method, headers, params } = payload

  const fetchAPI = async () => {
    return await axios({
      // `url` is the server URL that will be used for the request
      url: endpoint,

      // `method` is the request method to be used when making the request
      method,

      // `baseURL` will be prepended to `url` unless `url` is absolute.
      baseURL,

      // `headers` are custom headers to be sent
      headers,

      // `params` are the URL parameters to be sent with the request
      // Must be a plain object or a URLSearchParams object
      params,

      // `data` is the data to be sent as the request body
      // Only applicable for request methods 'PUT', 'POST', 'DELETE , and 'PATCH'
      data,
    })
  }

  async function reTryCatch(payload) {
    const { times = 1 } = payload

    try {
      const result = await fetchAPI()

      return result.data
    } catch (error) {
      if (times > 0) {
        return await reTryCatch({ times: times - 1 })
      } else {
        throw error
      }
    }
  }

  const result = await reTryCatch({ times: 2 })

  return result
}

export { useAxios }
